import { IManagementUnitResponse } from '../../../model/base/response/management-unit-response';

export type ManagementUnitsState = {
    units: IManagementUnitResponse[];
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setUnits = 'setUnits',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const ManagementUnitsReducer = (state: ManagementUnitsState, action: any): ManagementUnitsState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setUnits:
            return {
                ...state,
                units: payload,
                loading: false,
                error: null,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };
        case ACTION_TYPES.setError:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
